import { Guid, IBaseModel, Code } from '~/interfaces/base'
import { BaseState } from '~/classes/system/grid'
import emptyId from '~/statics/empty-id'
import { RowStates } from '~/enums/system'

export class Position implements BaseState {
  id: Guid
  rowState: RowStates
  title: string
  socialSecurityCode?: string
  financeDepartmentCode?: string

  constructor() {
    this.id = emptyId
    this.title = ''
    this.rowState = RowStates.New
  }
}